import { RotateCcwIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';

interface ClearFiltersButtonProps {
  onClick: () => void;
  activeFilterCount: number;
}

export const ClearFiltersButton = ({ onClick, activeFilterCount }: ClearFiltersButtonProps) => {
  const { t } = useTranslation();

  if (activeFilterCount === 0) {
    return null;
  }

  return (
    <InfoTooltip content={t('common.clear_all')} side="top">
      <Button
        variant="ghost-neutral"
        size="icon-sm"
        onClick={onClick}
        aria-label={t('common.clear_all')}
      >
        <RotateCcwIcon size={16} />
      </Button>
    </InfoTooltip>
  );
};
